import { render, staticRenderFns } from "./PageGoodsOrder.vue?vue&type=template&id=f18c1d48&scoped=true"
import script from "./PageGoodsOrder.vue?vue&type=script&lang=js"
export * from "./PageGoodsOrder.vue?vue&type=script&lang=js"
import style0 from "./PageGoodsOrder.vue?vue&type=style&index=0&id=f18c1d48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18c1d48",
  null
  
)

export default component.exports